// const FunctionsURL = 'http://127.0.0.1:5001/autism-connect-147c4/us-central1/addmessage2' // local version
const FunctionsURL = 'https://us-central1-resume-liam-fudge.cloudfunctions.net/addmessage2'  // hosted version

export default FunctionsURL